import React, { Suspense } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { ErrorBoundary } from 'components/ErrorBoundary';
import LoadingIndicator from 'components/LoadingIndicator';

interface AuthLayoutRouteProps extends RouteProps {
  component: any;
}

/** Guest-only route with no app chrome — same guard as layouts/GateLayout, minus the wrapper. */
export default function authLayoutRoute({ component: Component, ...rest }: AuthLayoutRouteProps) {
  const loggedIn = !!localStorage.getItem('token');
  return (
    <Route
      {...rest}
      render={(matchProps) =>
        !loggedIn ? (
          <Suspense fallback={<LoadingIndicator />}>
            <ErrorBoundary>
              <Component {...matchProps} />
            </ErrorBoundary>
          </Suspense>
        ) : (
          <Redirect push to={{ pathname: '/', state: { referrer: matchProps.location } }} />
        )
      }
    />
  );
}
